/* ==========================================================================
   Soka New Arrivals — Section JavaScript
   Vanilla JS only. No dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTORS = {
    section: '.soka-new-arrivals',
    addToCart: '[data-add-to-cart]',
    wishlist: '[data-wishlist-toggle]',
    quickView: '[data-quick-view]',
    card: '[data-product-card]'
  };

  /**
   * Add to cart handler — posts to /cart/add.js via fetch,
   * gives visual feedback, and dispatches a custom event so
   * other sections (cart drawer, cart count bubble) can react.
   */
  function handleAddToCart(button) {
    var variantId = button.getAttribute('data-variant-id');

    if (!variantId) {
      return;
    }

    if (button.getAttribute('data-loading') === 'true') {
      return;
    }

    var originalText = button.textContent;

    button.setAttribute('data-loading', 'true');
    button.textContent = 'Adding...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        button.removeAttribute('data-loading');

        if (!result.ok) {
          button.textContent = 'Unavailable';
          setTimeout(function () {
            button.textContent = originalText;
          }, 1800);
          return;
        }

        button.setAttribute('data-added', 'true');
        button.textContent = 'Added';

        document.dispatchEvent(
          new CustomEvent('soka:cart:add', {
            bubbles: true,
            detail: { item: result.data }
          })
        );

        setTimeout(function () {
          button.removeAttribute('data-added');
          button.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        button.removeAttribute('data-loading');
        button.textContent = 'Error';
        setTimeout(function () {
          button.textContent = originalText;
        }, 1800);
      });
  }

  /**
   * Wishlist placeholder — toggles pressed state and dispatches
   * a custom event. Hook this up to a real wishlist app/metafield
   * integration as needed.
   */
  function handleWishlistToggle(button, card) {
    var isPressed = button.getAttribute('aria-pressed') === 'true';
    var newState = !isPressed;

    button.setAttribute('aria-pressed', String(newState));

    document.dispatchEvent(
      new CustomEvent('soka:wishlist:toggle', {
        bubbles: true,
        detail: {
          added: newState,
          card: card
        }
      })
    );
  }

  /**
   * Quick view placeholder — dispatches a custom event with the
   * product handle. Hook this up to a modal/quick-view app as needed.
   */
  function handleQuickView(button) {
    var productHandle = button.getAttribute('data-product-handle');

    document.dispatchEvent(
      new CustomEvent('soka:quickview:open', {
        bubbles: true,
        detail: {
          handle: productHandle
        }
      })
    );
  }

  function initSection(section) {
    section.addEventListener('click', function (event) {
      var addToCartButton = event.target.closest(SELECTORS.addToCart);
      if (addToCartButton) {
        event.preventDefault();
        handleAddToCart(addToCartButton);
        return;
      }

      var wishlistButton = event.target.closest(SELECTORS.wishlist);
      if (wishlistButton) {
        event.preventDefault();
        var card = wishlistButton.closest(SELECTORS.card);
        handleWishlistToggle(wishlistButton, card);
        return;
      }

      var quickViewButton = event.target.closest(SELECTORS.quickView);
      if (quickViewButton) {
        event.preventDefault();
        handleQuickView(quickViewButton);
        return;
      }
    });
  }

  function init() {
    var sections = document.querySelectorAll(SELECTORS.section);
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-initialize when section is added/updated via Theme Editor */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SELECTORS.section);
    if (section) {
      initSection(section);
    }
  });
})();
